import "./PopupStyle.css";

interface Props {
  title: string;
  message: string;
  descriptions?: string;
  acceptText: string;
  cancelText: string;
  onAccept: () => void;
  onCancel: () => void;
}

const LogoutPopup = (props: Props) => {
  return (
    <div className="passwordPopup">
      <div className="popupWrap">
        <button className="closeBtn btnNoStyle" onClick={props.onCancel}>
          <img src={`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}OTHER/1756905526955-c0271464-cb65-48f4-9e31-eca932cc4407-cross-s.png`}
            alt="close"
          />
        </button>
        <div className="img">
          <img src="/assets/images/reset.png" alt="" />
        </div>
        <div className="titleBlock">
          <h2>{props.title}</h2>
          {props.descriptions && <p>{props.descriptions}</p>}
          {props.message && <p>{props.message}</p>}
        </div>
        <div className="bottomBlock d-flex justify-content-center">
          {props.acceptText && (
            <button
              className="lightBlueBtn"
              type="button"
              onClick={props.onAccept}
            >
              {props.acceptText}
            </button>
          )}
          {props.cancelText && (
            <button
              className="blueBorderBtn"
              type="button"
              onClick={props.onCancel}
            >
              {props.cancelText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogoutPopup;
